import React from 'react'

//Dependencies.
import { Col, Row } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import './WelcomeComponent.styles.css'


const WelcomeComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <Row>
        <Col xs={12} md={6} style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'green'}} onClick={() => navigate("/videos/all")}>
          <h1>ALL VIDEOS.</h1>
        </Col>
        <Col xs={12} md={6} style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'orange'}} onClick={() => navigate("../videos/currentUser")}>
          <h1>MY VIDEOS.</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'red' }} onClick={() => navigate("../../../../challenges/announcements/all")}>
          <h1>ALL UPCOMING CHALLENGES.</h1>
        </Col>
        <Col xs={12} md={6} style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'yellow'}} onClick={() => navigate("../challenges/announcements/currentUser")}><h1>MY UPCOMING CHALLENGES.</h1></Col>
      </Row>
      <Row>
        <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'whitesmoke' }} onClick={() => navigate("../challenges/actives/all")}>
          <h1>ALL ACTIVE CHALLENGES.</h1>
        </Col>
        <Col xs={12} md={6} style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', backgroundColor: 'lightseagreen'}} onClick={() => navigate("../challenges/actives/currentUser")}><h1>MY ACTIVE CHALLENGES.</h1></Col>
      </Row>
    </div>
  )
}

export default WelcomeComponent